import React from 'react';
import DataFilter from './DataFilter';
import LocationDataFilter from './LocationDataFilter';
import serializer from './serializer';
import useFilter from './useFilter';
import DEFAULT_FILTER from './defaultFilter';

var DataFilterExport = function DataFilterExport(props) {
  if (typeof props.value !== 'undefined' && typeof props.onChange !== 'undefined') return React.createElement(DataFilter, props);
  if (typeof props.location !== 'undefined' && typeof props.history !== 'undefined') return React.createElement(LocationDataFilter, props);
  return null;
};

DataFilterExport.defaultValue = DEFAULT_FILTER;
DataFilterExport.useFilter = useFilter;
DataFilterExport.createFromLocation = serializer.createFromLocation;
export default DataFilterExport;